import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalTitle,
  Text
} from '@qcx/ui';
import { shallow } from '@qcx/store';
import { useNewsStore } from '../../../news.store';

type AlertModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export type errorsType = 'default' | 'showMoreComments' | 'sendComment';
const ERRORS_MESSAGES: Record<
  errorsType,
  {
    title: string;
    description: string;
    confirmText: string;
  }
> = {
  default: {
    title: 'Ops!',
    description: 'Algo inesperado aconteceu! Por favor, tente novamente.',
    confirmText: 'Ok'
  },
  showMoreComments: {
    title: 'Não foi possível exibir mais comentários.',
    description:
      'Algo deu errado ao carregar mais comentários.Por favor, tente novamente.',
    confirmText: 'Ok'
  },
  sendComment: {
    title: 'Seu comentário não foi publicado.',
    description:
      'Houve um problema ao publicar seu comentário. Por favor, tente novamente.',
    confirmText: 'Ok'
  }
};

export const AlertModal = ({ isOpen, onClose }: AlertModalProps) => {
  const { type } = useNewsStore(s => s.alertModal, shallow);

  const { title, description, confirmText } = ERRORS_MESSAGES[type];

  return (
    <Modal
      open={isOpen}
      onOpenChange={(open: boolean) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <ModalContent
        css={{
          maxWidth: '480px',
          width: '100%',
          border: '1px solid #E5E7EB',
          borderRadius: '12px',
          padding: '0',
          backgroundColor: 'white',
          boxShadow:
            '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)'
        }}
      >
        <ModalBody css={{ padding: '24px' }}>
          <ModalTitle
            css={{
              mb: '$6',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            {title}
            <ModalCloseButton
              css={{ position: 'relative', top: '$0', right: '$0' }}
              onPress={onClose}
            />
          </ModalTitle>

          <Text
            css={{
              fontSize: '$md',
              color: '#667085',
              marginBottom: '$6'
            }}
          >
            {description}
          </Text>

          <Box css={{ display: 'flex', justifyContent: 'flex-end', gap: '$4' }}>
            <Button
              css={{
                backgroundColor: '#FE6112',
                color: 'white',
                padding: '10px 16px',
                fontSize: '15px',
                fontWeight: '$semibold',
                borderRadius: '8px',
                border: 'none',
                cursor: 'pointer',
                '&:hover': {
                  bgColor: '#FE6112 !important',
                  color: 'white !important',
                  opacity: '0.9 !important'
                }
              }}
              onClick={onClose}
            >
              {confirmText}
            </Button>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
